module.exports = __webpack_public_path__ + "static/media/home.6d49a954.png";